const Loyalty = ({ data, animatedPoints, booking }) => {

    const getNextTierInfo = (points) => {
        if (points >= 2000) return { tier: 5, next: null };
        if (points >= 1000) return { tier: 4, next: 2000 - points };
        if (points >= 500) return { tier: 3, next: 1000 - points };
        if (points >= 250) return { tier: 2, next: 500 - points };
        return { tier: 1, next: 250 - points };
    };

    const nextTierInfo = getNextTierInfo(data.points);
    const firstName = booking.booker?.first_name || "Guest";

    return (
        <div className="loyalty-info">
            <div className="loyalty-reward">
                <span>+</span>
                <strong>{animatedPoints}</strong>
            </div>

            <p className="loyalty-greeting">Dear <strong>{firstName}</strong>,</p>
            <h2>Loyalty Points Earned</h2>

            <div className="loyalty-stats">
                <div className="loyalty-stat">
                    <span>Points Balance</span>
                    <strong>{animatedPoints}</strong>
                </div>
                <div className="loyalty-stat">
                    <span>Loyalty Tier</span>
                    <strong>{data.loyalty_tier}</strong>
                </div>
            </div>

            {nextTierInfo?.next ? (
                <p className="loyalty-progress">Only <strong>{nextTierInfo.next}</strong> points to reach Tier {nextTierInfo.tier + 1}.</p>
            ) : (
                <p className="loyalty-progress">Congratulations, you have reached the highest loyalty tier.</p>
            )}
            <a href="/loyalty" className="loyalty-link">
                View loyalty benefits
            </a>
        </div>
    )
}

export default Loyalty
